<div *ngFor="let selectedCondition of existingConditions; let i = index" class="filters">
  <app-automation-condition-builder-item
    [hideAddRemove]="hideAddRemove"
    [selectedCondition]="selectedCondition"
    [availableConditions]="availableConditions"
    [index]="i"
    (delete)="deleteFilter(i)"
    (addSubCondition)="addSubCondition(selectedCondition)"
  >
  </app-automation-condition-builder-item>
  <div *ngIf="selectedCondition.isSubFilterAdded" class="sub-conditions">
    <div *ngFor="let selectedSubCondition of selectedCondition.selectedSubConditions; let i = index" class="filters">
      <app-automation-condition-builder-item
        [isSubCondition]="true"
        [hideAddRemove]="hideAddRemove"
        [selectedCondition]="selectedSubCondition"
        [availableConditions]="selectedCondition.filter.subConditionItems"
        [index]="i"
        (delete)="deleteSubFilter(selectedCondition, i)"
      >
      </app-automation-condition-builder-item>
    </div>
    <button class="add-filter-button" mat-button color="primary" (click)="addSubCondition(selectedCondition)">
      <mat-icon>add_circle</mat-icon> ADD SUB-CONDITION
    </button>
  </div>
</div>
<button class="add-filter-button" mat-button color="primary" (click)="addCondition()" *ngIf="!hideAddRemove">
  + ADD CONDITION
</button>

<p class="filter-panel-action-buttons" style="position: relative" *ngIf="showError" class="error-message">
  Please make sure to select all values, or remove the filter before applying.
</p>
